<template>
  <v-card>
    <v-card-title
      class="pr-2"
      :style="{ backgroundColor: companyPrimaryColor }"
    >
      <h2 style="color:white">Cli&euml;nt toevoegen aan wachtrij</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeAddClientQueueDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <div class="hogans-alerts">
      <v-alert v-if="feedback" :value="true" type="warning">
        {{ feedback }}
      </v-alert>
    </div>

    <v-divider></v-divider>

    <v-card-text>
      <v-form ref="AddClientQueueForm" v-model="valid" lazy-validation>
        <v-text-field
          label="Naam"
          v-model="newQueue.name"
          :rules="requiredRules"
          prepend-icon="account_box"
          required
        ></v-text-field>
        <v-text-field
          label="Telefooonnummer"
          v-model="newQueue.phone"
          :mask="maskPhonenumber"
          :rules="requiredRules"
          prepend-icon="phone"
          required
        ></v-text-field>
        <v-text-field
          label="Behandeling"
          v-model="newQueue.treatment"
          required
          :rules="requiredRules"
          prepend-icon="event_seat"
        ></v-text-field>
        <v-select
          v-model="newQueue.treatmentTime"
          :items="treatmentTimes"
          label="Behandeltijd"
          prepend-icon="timer"
          required
        ></v-select>
        <v-menu
          ref="dateDialog"
          :close-on-content-click="false"
          v-model="queueEndDateDialog"
          transition="scale-transition"
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :color="companyPrimaryColor"
              v-on="on"
              v-model="queueEndDateFormatted"
              label="Einddatum"
              hint="Tot wanneer wordt de klant weergegeven op de wachtlijst?"
              persistent-hint
              prepend-icon="today"
              readonly
            ></v-text-field>
          </template>
          <v-date-picker
            :color="companyPrimaryColor"
            v-model="newQueue.queueEndDate"
            :min="today"
            :show-current="true"
            no-title
            @input="queueEndDateDialog = false"
          ></v-date-picker>
        </v-menu>

        <v-select
          v-if="branches.length > 1"
          v-model="newQueue.branch"
          :items="branches"
          label="Selecteer salon"
          item-text="branchName"
          item-value="id"
          prepend-icon="location_on"
          required
          :rules="requiredRules"
        ></v-select>
        <v-text-field
          label="Gewenste medewerker"
          v-model="newQueue.employee"
          required
          prepend-icon="face"
        ></v-text-field>
        <v-textarea
          label="Opmerkingen"
          v-model="newQueue.notes"
          required
          prepend-icon="feedback"
        ></v-textarea>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex
            xs12
            md6
            class="text-left"
            v-if="
              $vuetify.breakpoint.name != 'sm' &&
                $vuetify.breakpoint.name != 'xs'
            "
          >
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeAddClientQueueDialog()"
            >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              dark
              rounded
              :block="
                $vuetify.breakpoint.name == 'sm' ||
                  $vuetify.breakpoint.name == 'xs'
              "
              :color="companySecondaryColor"
              @click="addClientToQueue()"
            >
              Toevoegen aan wachtlijst
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import { bus } from "../../main";
import db from "../../firebase/init";
import firebase from "firebase/compat/app";
import platform from "platform";
import moment from "moment";

export default {
  name: "add-client-queue-form",
  props: ["branches"],
  data() {
    return {
      valid: false,
      newQueue: {
        name: null,
        phone: null,
        salonhubId: null,
        treatment: null,
        treatmentTime: "30 min",
        queueEndDate: null,
        branch: null,
        employee: null,
        notes: null,
      },
      maskPhonenumber: "####-## ## ##",
      queueEndDateDialog: false,
      requiredRules: [(v) => !!v || "Dit veld is verplicht"],
      treatmentTimes: [
        "20 min",
        "30 min",
        "40 min",
        "50 min",
        "1 uur",
        "1,5 uur",
        "> 1,5 uur",
        "Onbekend",
      ],
      today: null,
      emailRules: [
        (v) => !!v || "E-mail is verplicht",
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid",
      ],
      feedback: null,
    };
  },

  created() {
    // Datum van vandaag en eindatum alvast
    this.today = moment().format("YYYY-MM-DD");
    this.newQueue.queueEndDate = moment()
      .add(2, "weeks")
      .format("YYYY-MM-DD");

    bus.$on("setQueueBranch", (startDate) => {
      this.newQueue.branch = this.branches[0].id;
    });
    bus.$on("setQueueBranchAndData", (chosenCustomerInfo) => {
      this.newQueue.salonhubId = chosenCustomerInfo.customer;
      this.newQueue.branch = this.branches[0].id;

      if (chosenCustomerInfo.firstname && chosenCustomerInfo.lastname) {
        this.newQueue.name =
          chosenCustomerInfo.firstname + " " + chosenCustomerInfo.lastname;
      }

      if (chosenCustomerInfo.telephoneMobile) {
        this.newQueue.phone = chosenCustomerInfo.telephoneMobile;
      } else if (chosenCustomerInfo.telephoneHome) {
        this.newQueue.phone = chosenCustomerInfo.telephoneHome;
      }

      if (
        chosenCustomerInfo.treatments &&
        chosenCustomerInfo.treatments.length > 0
      ) {
        this.newQueue.treatment = chosenCustomerInfo.treatments[0].description;
        this.newQueue.employee = chosenCustomerInfo.treatments[0].employeeName;
      }
    });
  },

  methods: {
    closeAddClientQueueDialog() {
      this.$emit("newQueueDialogChange", false);
      this.feedback = null;
      this.newQueue = {
        name: null,
        phone: null,
        salonhubId: null,
        treatment: null,
        treatmentTime: "30 min",
        queueEndDate: null,
        branch: null,
        employee: null,
        notes: null,
      };
    },

    addClientToQueue() {
      if (this.$refs.AddClientQueueForm.validate()) {
        db.collection("clientQueue")
          .add({
            // Basic Company Settings
            name: this.newQueue.name,
            compId: this.userCompany,
            salonhubId: this.newQueue.salonhubId,
            phone: this.newQueue.phone,
            branch: this.newQueue.branch,
            treatment: this.newQueue.treatment,
            treatmentTime: this.newQueue.treatmentTime,
            queueEndDate: new Date(this.newQueue.queueEndDate),
            employee: this.newQueue.employee,
            notes: this.newQueue.notes,
            deleted: {
              deleted: false,
            },
            scheduled: false,
            dateAdded: new Date(),
          })
          .then(() => {
            db.collection("log").add({
              time: new Date(),
              logType: "info",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              software: String(platform.os),
              browser: platform.name + " " + platform.version,
              pillarrrVersion: this.$store.state.version,
              action: this.newQueue.name + " toegevoegd aan wachtrij: ",
              extra:
                "<b>Naam</b>: " +
                this.newQueue.name +
                "<br>" +
                "<b>Behandeling</b>: " +
                this.newQueue.treatment +
                "<br>" +
                "<b>Einddatum voor wachten</b>: " +
                this.newQueue.queueEndDate,
            });
          })
          .then(() => {
            this.$emit("updateData");
            this.closeAddClientQueueDialog();
            bus.$emit("loadCompanyQueue");
            console.log("ClientQueue succesfully added");
          })
          .catch((error) => {
            console.error("Error adding ClientQueue: ", error);
            db.collection("log").add({
              time: new Date(),
              logType: "error",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              action: "Error adding ClientQueue: " + this.activeCompName,
              software: String(platform.os),
              browser: platform.name + " " + platform.version,
              pillarrrVersion: this.$store.state.version,
              extra: JSON.stringify(error),
            });
          });
      } else {
        this.feedback =
          "Vul alle velden in om cliënt toe te voegen aan wachtlijst.";
      }
    },
    formatDate(date) {
      // Datum omvormen naar Europese leesbare datum
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
  },
  computed: {
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    queueEndDateFormatted() {
      // Datum omvormen naar Europese leesbare datum
      return this.formatDate(this.newQueue.queueEndDate);
    },
  },
};
</script>
